// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"PendingUsersItem_gridContainer__2eNdT","gridItem":"PendingUsersItem_gridItem__2gGp6"};